import { useIsDesktop } from "common/MediaQueries"
import { useScrollDirection } from "common/bit/hooks/useScrollDirection"
import { ScrollingProvider, Section } from "common/bit/scrollSection"
import CarModelNavBar from "components/carModelPage/navigation/CarModelNavBar"
import { useScroll } from "framer-motion"
import Header from "layout/header/Header"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { keyFrameFadeOut } from "theme/animation"
import { HEADER_ANIME_D, HEADER_ANIME_M } from "theme/shared"
import CarsContent from "./CarsContent"
import ImageWithText from "./ImageWithText"
import InnerContent from "./InnterContent"

const nevergiveupData = {
  upper: {
    title: "באהבה ובאומץ מהירושימה",
    description: [
      "תעוזה והרפתקה - אלו הן שתי התכונות המאפיינות כל מכונית שיוצאת מהבית של מאזדה בהירושימה שביפן. בדומה לעוף החול, הפניקס, גם הירושימה התעוררה מאבק ההפצצה האטומית. האנשים שגרו באזור התגברו על אתגרים נוראיים שוב ושוב כשהם מסרבים להפסיק לחלום על עתיד טוב יותר. אומץ וכוח סבל היו הבסיס לשיקומה של הירושימה והם מקור ההשראה של מאזדה.",
      "במאזדה מוכנים לכל אתגר בדרך ליצירת מכוניות מדהימות. קשה ככל שתהיה הדרך, לעולם לא עוצרים, לעולם לא מוותרים.",
    ],
    images: [
      "/img/aboutUs/sectionOne/ourstory2.jpg",
      "/img/aboutUs/sectionOne/ourstory1.jpg",
    ],
  },

  middle: {
    title: "התמודדות יצירתית עם מסע מפרך",
    description: [
      "כולם במאזדה הרפתקנים מלידה, לא מתביישים למרוד כשצריך. חושבים אחרת וצועדים קדימה, ממשיכים לשבור מוסכמות ומתמודדים עם האתגר שביצירת מכוניות שטרם נראו. האתגר מוציא את המקסימום ומעורר את החדשנות ואת היצירתיות.",
      "רוח נועזת זו מקורה בשורשים העמוקים של מאזדה, מחדר העיצוב ועד רצפת הייצור. לנסוע אל המקומות שאף אחד לא הגיע אליהם לפני כן. זוהי הנוסחה המנצחת.",
    ],
  },

  bottom: {
    title: '"ONE MAZDA": כשמשלבים בין רעיונות חדשניים, מרגישים בניצוץ',
    description: [
      "עבודת צוות היא מילת המפתח. כולם במאזדה מחויבים לעבודת צוות משותפת; הרעיונות ומקורות ההשראה יכולים להגיע מכל אחד בחברה, וביחד הם מדליקים את להבת החדשנות.",
      `תרבות ה- "One Mazda" הזו משקפת את המבנה הייחודי של החברה. בדרך כלל הפעילויות החיוניות של יצרני הרכב, פיתוח, ייצור ושיווק, פזורות באזורים שונים. במאזדה, הכל מרוכז במקום אחד, במטה הראשי של החברה שבהירושימה. במתקן מרוכז זה, קל למעצבים, למהנדסים, לעובדי המפעל ולאנשי השיווק לפעול יחד כדי למצוא רעיונות למכוניות נפלאות.`,
      `כיוון שהחברה התפתחה בכל העולם, תרבות ה-"One Mazda" והרוח הנועזת שלה יצאה את גבולות הירושימה והגיעו עד למשרדים ולמפעלים בכל העולם. זהו מסע של תעוזה והרפתקה, והמכוניות של מאזדה ימשיכו לעורר השראה ויגרמו לדופק לעלות.`,
    ],
    images: [
      "/img/aboutUs/sectionOne/ourstory4.jpg",
      "/img/aboutUs/sectionOne/ourstory3.jpg",
    ],
  },
}

const challengesData = {
  upper: {
    title: "אגדת המנוע הרוטורי: לעשות את הבלתי אפשרי",
    description: [
      "מכוניות עם מנוע רוטורי בכבישים. זה היה האתגר המדהים שמאזדה התמודדה איתו בהצלחה לפני כמעט חמישים שנה. באותם הימים, ייצור מנוע רוטורי אמיתי המשלב בין הספק גבוה וממדים קומפקטיים היה חלום רחוק.",
      "מהנדסים בכל רחבי העולם ניסו להגשים אותו ללא הצלחה, עד שבשנת 1967 הצליח צוות מהנדסים במאזדה להגיע לפריצת דרך משמעותית. לאורך הדרך, נתקל שוב ושוב הצוות בקשיים, אך לבסוף הוא הצליח לחצות את קו הסיום עם מכונית הספורט האייקונית, ה-Cosmo. המהנדסים המוכשרים השיגו את הבלתי אפשרי והפכו לאגדה בזכות התמדה ללא פשרות, תשוקה וחדשנות.",
    ],
    images: [
      "/img/aboutUs/sectionTwo/story2.jpg",
      "/img/aboutUs/sectionTwo/story1.jpg",
    ],
  },

  middle: {
    title: "הניצחון בלה-מאן לאחר שפל ארוך",
    description: [
      "בשנת 1991 טלטלה מאזדה את עולם הספורט המוטורי. המאזדה 787B, שצוידה במנוע מוטורי, זכתה במרוץ 24 השעות של לה-מאן. זכייתה של מאזדה במרוץ המאתגר הזה, שבוחן את עמידותם ויעילותם של המנועים, הוא הסיפור הקלאסי של האנדרדוג.",
      "מאזדה השתתפה תחילה במרוץ שנערך בשנת 1973. היא אומנם לא הגיעה לקו הסיום אך זכתה להתמודד עם האתגר ולהביס מתחרים ותיקים. עם ניצחונה בשנת 1991, הפכה מאזדה ליצרן הרכב האסייתי הראשון והיחיד שעשה זאת. זה היה גם הניצחון הראשון למנוע הרוטורי. ושוב, ההתמדה והתשוקה של מאזדה הובילו ליצירתה של אגדה.",
    ],
  },

  bottom: {
    title: "SKYACTIV: עוד מאה שנה, עוד חידוש",
    description: [
      "המסע של מאזדה לעבר התמדה, תשוקה וחדשנות המשיך גם במאה החדשה. בגלל הרצון לפרוץ דרכים חדשות, פותחה טכנולוגית ה-SKYACTIV, משפחה של טכנולוגיות מתקדמות המאפשרות לתעל במלואו את הפוטנציאל הטמון במנועי הבנזין והדיזל.",
      "לדוגמה, מנוע הבנזין SKYACTIV-G הגיע לרמה חדשה לגמרי של חיסכון בדלק, הספק ופליטת מזהמים הודות ליחס דחיסה של 14:1, נתון המתקבל רק במכונית מרוצים.",
      'כתבי רכב רבים ממדינות שונות בעולם אימצו את טכנולוגיית ה-SKYACTIV והעניקו לה פרסים שונים, כולל תוארי "מכונית השנה". אבל חשוב מכך, דור חדש של מכוניות זוכה לאהדת הנהגים. ההתרגשות בקרב חובבי ההגה כמו גם התשוקה של צוות המהנדסים המשיכה להאיץ את מנוע החדשנות של מאזדה.',
    ],
    images: [
      "/img/aboutUs/sectionTwo/story4.jpg",
      "/img/aboutUs/sectionTwo/story3.jpg",
    ],
  },
}

const manufactoringData = {
  upper: {
    title: "אומנות מעוררת השראה",
    description: [
      `כדי ליצור מכונית עם חיים משלה דרוש מגע של אומן אמיתי. ביפן הוא נקרא "טקומי", מאסטר שמשתמש בדמיון כדי להפוך מוצרים שימושיים למשהו מפתה ומהנה. ייצור רכב הוא יותר מסתם בניית אמצעי תחבורה לאנשים, הוא מתמקד ביצירת משהו חי, משהו עם נשמה. רק מכוניות עם נשמה יכולות לרתק ולענג. מכוניות כאלה נולדות רק כאשר יצירתיות פוגשת אומנות, כאשר מה שמניע את התכנון ההנדסי הוא הדמיון. במאזדה יוצקים את התשוקה והמיומנויות לתוך המכוניות כדי להגיע לשיאי היצירתיות של אומן הטקומי. מאזדה אינה מוותרת לא על הדמיון ולא על האומנות. מתוך תהליך של שלמות יצירתית באות לעולם מכוניות נפלאות.`,
    ],
    images: [
      "/img/aboutUs/sectionThree/story1.jpg",
      "/img/aboutUs/sectionThree/story2.jpg",
      "/img/aboutUs/sectionThree/story3.jpg",
    ],
  },
  middle: {
    title: "MX-5: מציתה את הדמיון",
    description: [
      `ה-MX-5 מזקקת יותר מכל מכונית אחרת את האתוס שמאחורי מאזדה: כדי ליצור צריך דמיון. עם האצה מדהימה ובלימה עוצמתית, ה-MX-5 מעלה את הדופק ומשחררת את הדמיון כך שתרגישו שאתם ממש חלק מהמכונית. זו חוויה המאפיינת את כל דגמי מאזדה, אבל את ה-MX-5 במיוחד. מאז נחיתתה בסצנת מכוניות הספורט בשנת 1989, ה-MX-5 המשיכה ללכוד מבטים ולכבוש לבבות.`,
      'בזכות כוח המשיכה העוצמתי של ה-MX-5 היא זכתה בתואר "מכונית הספורט הדו-מושבית הנמכרת ביותר" של ספר השיאים של גינס. את האדרנלין מרגישים מהרגע שנכנסים אליה.',
    ],
    images: [
      "/img/aboutUs/sectionThree/story5.jpg",
      "/img/aboutUs/sectionThree/story4.jpg",
    ],
  },
  bottom: {
    title: "ללכוד את היופי החייתי",
    description: [
      'יצירה המבטאת את היופי האצילי ואת העוצמה החייתית בתנועה. זהו הרעיון שמאחורי המושג KODO - שפת העיצוב של מאזדה: הנשמה שבתנועה. הרעיון הזה מזוקק באמצעות דמיון חופשי ואומנות מחושבת המשתלבות הודות לשיתוף פעולה צמוד בין המעצב, אשר משרטט את הפנטזיה על נייר, ובין אומן החימר, אשר הופך את הרעיון לצורה אמיתית. כל פרט קטנטן נחשב. תוך התמקדות ברעיון זה, צוות העיצוב חוצה את הגבולות שבין הפנטזיה והמציאות במטרה למצוא את הדרך הטובה ביותר ליצוק את "הנשמה שבתנועה" אל תוך הרכבים.',
    ],
    images: [
      "/img/aboutUs/sectionThree/story6.jpg",
      "/img/aboutUs/sectionThree/story7.jpg",
    ],
  },
}

const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 80px;
  background: ${(p) => p.theme.colors.white};
  section {
    padding-bottom: 100px;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-top: 50px;
  }
`

const StyledHeaderCarPage = styled(Header)<{ $exit: boolean }>`
  animation: ${(p) => p.$exit && keyFrameFadeOut} 0.5s ease-in-out forwards;
`

const StyledPageDiv = styled.div`
  width: 100vw;
  min-height: max-content;
  height: max-content;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const StyledInnerContentWrapper = styled.div`
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-left: 20px;
    padding-right: 20px;
  }
`

const StyledCarModelNavBar = styled(CarModelNavBar)<{
  $exit: boolean
  $isPastThreshold: boolean
}>`
  z-index: ${(p) => p.$exit && "1251"};
  transform: ${(p) => !p.$exit && p.$isPastThreshold && "translateY(50px)"};
  transition: ${(p) =>
    !p.$exit &&
    p.$isPastThreshold &&
    "all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms"};
  ${(p) => p.theme.breakpoints.up("md")} {
    transform: ${(p) => !p.$exit && p.$isPastThreshold && "translateY(80px)"};
  }
`

const AboutUsPage = () => {
  const isDesktop = useIsDesktop()
  const scrollDirection = useScrollDirection()
  const [isPastThreshold, setIsPastThreshold] = useState(false)
  // Value being driven by scrolling (e.g. height)
  const thresholdY = 2 // set the scroll position where you want the state change
  const { scrollY } = useScroll()

  useEffect(
    () =>
      scrollY.onChange((latest) => {
        setIsPastThreshold(latest > thresholdY)
      }),
    []
  )
  return (
    <ScrollingProvider offset={isDesktop ? HEADER_ANIME_D : HEADER_ANIME_M}>
      <StyledPageWrapper>
        <StyledCarModelNavBar
          $exit={scrollDirection === "down"}
          $isPastThreshold={isPastThreshold}
        />
        <StyledHeaderCarPage narrow={true} $exit={scrollDirection === "down"} />
        <Section title="לעולם לא לוותר" id="nevergiveup">
          <StyledPageDiv>
            <ImageWithText
              image={
                isDesktop
                  ? "/img/aboutUs/nevergiveup.jpg"
                  : "/img/aboutUs/nevergiveupMobile.png"
              }
              title="מסע של תעוזה והרפתקה"
              subtitle="לנסוע אל המקומות שאף אחד לא הגיע אליהם לפני כן"
            />
            <StyledInnerContentWrapper>
              <InnerContent nevergiveupData={nevergiveupData.upper} />
              <InnerContent
                nevergiveupData={nevergiveupData.middle}
                imageSource="/img/aboutUs/sectionOne/brandStory.jpg"
              />
              <InnerContent nevergiveupData={nevergiveupData.bottom} />
            </StyledInnerContentWrapper>
          </StyledPageDiv>
        </Section>
        <Section title="להשיג את הבלתי אפשרי" id="challenges">
          <StyledPageDiv>
            <ImageWithText
              image={
                isDesktop
                  ? "/img/aboutUs/challengesDesktop.jpg"
                  : "/img/aboutUs/challengesMobile.png"
              }
              title="דרך ארוכה ומפותלת לעבר הקדמה והתשוקה"
              subtitle="אגדת המנוע המוטורי, הניצחון בלה-מאן, מהפכת ה-SKYACTIV"
            />
            <StyledInnerContentWrapper>
              <InnerContent nevergiveupData={challengesData.upper} />
              <InnerContent
                nevergiveupData={challengesData.middle}
                imageSource="/img/aboutUs/sectionTwo/story5.jpg"
              />
              <InnerContent nevergiveupData={challengesData.bottom} />
            </StyledInnerContentWrapper>
          </StyledPageDiv>
        </Section>
        <Section title="ליצור עם דמיון" id="manufactoring">
          <StyledPageDiv>
            <ImageWithText
              image={
                isDesktop
                  ? "/img/aboutUs/manufactoringDesktop.jpg"
                  : "/img/aboutUs/manufactoringMobile.png"
              }
              title="כדי ליצור צריך דמיון"
              subtitle="בזכות כוח הדמיון, מאזדה מייצרת מכוניות עם נשמה אמיתית."
            />
            <StyledInnerContentWrapper>
              <InnerContent nevergiveupData={manufactoringData.upper} />
              <InnerContent nevergiveupData={manufactoringData.middle} />
              <InnerContent nevergiveupData={manufactoringData.bottom} />
            </StyledInnerContentWrapper>
          </StyledPageDiv>
        </Section>
        <Section title="רכבים נפלאים" id="greatCars">
          <StyledPageDiv>
            <ImageWithText
              image={
                isDesktop
                  ? "/img/aboutUs/greatcarsDesktop.jpg"
                  : "/img/aboutUs/greatcarsMobile.png"
              }
              title="היסטוריה של רכבים נפלאים"
            />
            <CarsContent />
          </StyledPageDiv>
        </Section>
      </StyledPageWrapper>
    </ScrollingProvider>
  )
}

export default AboutUsPage
